import classes from "./AddObjectiveForm.module.css";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import serverPostData from "../../utils/ServerPostData";
import { useNavigate } from "react-router-dom";
import MapComponent from "../Map/Map";
import Backdrop, { DoubleBackdrop } from "../BackDrop/BackDrop";
import DarkModeContext from "../../store/DarkModeContext";
import { useContext } from "react";
import { lightModeColors, darkModeColors } from "../../utils/colors";

function ObjectiveForm(props) {
  const [tg, i18] = useTranslation("global");
  const [name, setName] = useState("");
  const [pointValue, setPointValue] = useState("");
  const [maxPerUser, setMaxPerUser] = useState("");
  const [coolDownTime, setCoolDownTime] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [description, setDescription] = useState("");
  const [radius, setRadius] = useState("");
  const [refreshRate, setRefreshRate] = useState("");
  const [location, setLocation] = useState("");
  const [repCounter, setRepCounter] = useState("");
  const [hideOnMobile, setHideOnMobile] = useState("");
  const [wallet, setWallet] = useState("councilWallet");

  const [nameError, setNameError] = useState("");
  const [pointValueError, setPointValueError] = useState("");
  const [maxPerUserError, setMaxPerUserError] = useState("");
  const [coolDownTimeError, setCoolDownTimeError] = useState("");
  const [dueDateError, setDueDateError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [radiusError, setRadiusError] = useState("");
  const [refreshRateError, setRefreshRateError] = useState("");
  const [repCounterError, setRepCounterError] = useState("");
  const [hideOnMobileError, setHideOnMobileError] = useState("");

  const formData = new FormData();
  const navigate = useNavigate();
  const [showMap, setShowMap] = useState(false);

  const { darkMode} = useContext(DarkModeContext);
  const { textColor, backgroundColor, cardColor } = darkMode ? darkModeColors : lightModeColors;

  //const [name, setName] = useState("");
  const handleShowMap = () => {
    setShowMap((prevShowMap) => !prevShowMap);
  };

  function cancelHandler() {
    props.cancel();
  }

  function handleDateChange(ev) {
    if (!ev.target["validity"].valid) return;
    const dt = new Date(ev.target.value).toISOString();
    setDueDate(dt);
  }
  function backdropHandlerDeactivate() {
    setShowMap(false);
  }

  function handlerOnDoneClick() {
    setShowMap(false);
  }

  function handleLocationClick(location) {
    setLocation(location);
    console.log("props" + location);
    if (location == null) console.log("NULL");
  }

  function confirmHandler(event) {
    event.preventDefault();
    if (showMap) {
      return;
    }

    setNameError("");
    setPointValueError("");
    setMaxPerUserError("");
    setCoolDownTimeError("");
    setDueDateError("");
    setDescriptionError("");
    setRadiusError("");
    setRefreshRateError("");
    setRepCounterError("");
    setHideOnMobileError("");

    if (
      "" === name ||
      "" === pointValue ||
      // "" === maxPerUser ||
      // "" === coolDownTime ||
      "" === dueDate ||
      "" === description //||
      // "" === radius ||
      // "" === refreshRate ||
      // "" === repCounter
    ) {
      if ("" === name) {
        setNameError(tg("objectives.input_error.name"));
      }
      if ("" === pointValue) {
        setPointValueError(tg("objectives.input_error.point"));
      }
      // if ("" === maxPerUser) {
      //   setMaxPerUserError(tg("objectives.input_error.maxPerUser"));
      // }
      // if ("" === coolDownTime) {
      //   setCoolDownTimeError(tg("objectives.input_error.coolDownTime"));
      // }
      if ("" === dueDate) {
        setDueDateError(tg("objectives.input_error.dueDate"));
      }
      if (dueDate <= new Date().toISOString()) {
        setDueDateError(tg("objectives.input_error.dueDate"));
      }
      if ("" === description) {
        setDescriptionError(tg("objectives.input_error.description"));
      }
      // if ("" === radius) {
      //   setRadiusError(tg("objectives.input_error.radius"));
      // }
      // if ("" === refreshRate) {
      //   setRefreshRateError(tg("objectives.input_error.refreshRate"));
      // }
      // if ("" === repCounter) {
      //   setRepCounterError(tg("objectives.input_error.repCounter"));
      // }
      return;
    }

    if (
      nameError === "" &&
      pointValueError === "" &&
      descriptionError === "" &&
      dueDateError === "" //&&
      // coolDownTimeError === "" &&
      // radiusError === "" &&
      // refreshRateError === "" &&
      // repCounterError === "" 
    ) {
      formData.append("title", name);
      formData.append("adminID", localStorage.getItem("userId"));
      formData.append("coolDownTime", coolDownTime);
      formData.append("coordinates", location);
      formData.append("radius", radius);
      formData.append("creationDate", new Date().toISOString());
      formData.append("description", description);
      formData.append("dueDate", dueDate);
      // formData.append("qrID", 0);
      formData.append("maxScans", maxPerUser);
      // formData.append("nfcID", 0);
      formData.append("pointValue", pointValue);
      formData.append("wallet", wallet);
      formData.append("refreshRate", refreshRate);
      formData.append("repCounter", repCounter);
      formData.append("hideOnMobile", hideOnMobile);

      console.log(formData);

      //console.log(dataToSend);
      //console.log('SUCCESS');
      const serverResponse = serverPostData(
        "/dashboard-add-objective",
        formData
      );
      serverResponse.then((response) => {
        let data = response;

        if (data.status === 200) {
          alert(tg("objectives.general.success"));
          //refresh the page
          window.location.reload();
        } else {
          alert(tg("objectives.general.error"));
        }
      });

      props.confirm();
    }
    else {
      alert(tg("objectives.general.error"));
    }
  }

  return (
    <div className={classes.form} style={{"--card-color": cardColor,"--text-color": textColor}}>
      <p>{tg("objectives.add.new_objective")}</p>
      <form id="add_objective" onSubmit={confirmHandler}>
        <input
          className={classes.fieldBox}
          type="text"
          placeholder={tg("objectives.form.name")}
          name="fname"
          onChange={(e) => setName(e.target.value)}
        />
        <div>
          <label className={classes.errorLabel}>{nameError}</label>
        </div>

        <div className={classes.fieldBox}>
          <label className={classes.fieldLabels} htmlFor="pointValue">
            {tg("objectives.form.point")}
          </label>
          <input
            className={classes.inputBox}
            type="number"
            min="0"
            name="fname"
            onChange={(e) => setPointValue(e.target.value)}
          />
        </div>
        <div>
          <label className={classes.errorLabel}>{pointValueError}</label>
        </div>
        <div className={classes.fieldBox}>
          <label className={classes.fieldLabels} htmlFor="type">
            {tg("objectives.form.type")}
          </label>
          <select
          className={classes.select_button}
          name="PreviousReceiver"
          onChange={(e) => setWallet(e.target.value)}
        >
          <option value="councilWallet">{tg("global.wallet.walletCouncil")}</option>
          <option value="schoolWallet">{tg("global.wallet.walletSchool")}</option>
          <option value="marketWallet">{tg("global.wallet.walletMarket")}</option>
          
        </select>
        
        </div>

        <div className={classes.fieldBox}>
          <label className={classes.fieldLabels} htmlFor="repCounter">
            {tg("objectives.form.repCounter")}
          </label>
          <input
            className={classes.inputBox}
            type="number"
            min="0"
            name="fname"
            onChange={(e) => setRepCounter(e.target.value)}
          />
        </div>
        <div>
          <label className={classes.errorLabel}>{repCounterError}</label>
        </div>

        <div className={classes.fieldBox}>
          <label className={classes.fieldLabels} htmlFor="maxPerUser">
            {tg("objectives.form.maxPerUser")}
          </label>
          <input
            className={classes.inputBox}
            type="number"
            min="0"
            name="fname"
            onChange={(e) => setMaxPerUser(e.target.value)}
          />
        </div>
        <div>
          <label className={classes.errorLabel}>{maxPerUserError}</label>
        </div>

        <div className={classes.fieldBox}>
          <label className={classes.fieldLabels} htmlFor="coolDownTime">
            {tg("objectives.form.coolDownTime")}
          </label>
          <input
            className={classes.inputBox}
            type="number"
            step="any"
            min="0"
            name="fname"
            onChange={(e) => setCoolDownTime(e.target.value)}
          />
        </div>
        <div>
          <label className={classes.errorLabel}>{coolDownTimeError}</label>
        </div>

        <div className={classes.fieldBox}>
          <label className={classes.fieldLabels} htmlFor="dueDate">
            {tg("objectives.form.dueDate")}
          </label>
          <input
            type="datetime-local"
            className={classes.inputBox}
            id="dueDate"
            defaultValue={new Date().toISOString().split(".")[0].slice[(0, 16)]}
            onChange={(e) => handleDateChange(e)}
          />
        </div>
        <div>
          <label className={classes.errorLabel}>{dueDateError}</label>
        </div>

        <input
          className={classes.fieldBox}
          type="text"
          placeholder={tg("objectives.form.description")}
          name="fname"
          onChange={(e) => setDescription(e.target.value)}
        />
        <div>
          <label className={classes.errorLabel}>{descriptionError}</label>
        </div>

        <div className={classes.fieldBox}>
          <label className={classes.fieldLabels} htmlFor="location">
            {" "}
            {tg("objectives.form.location")}
          </label>
          <button onClick={handleShowMap}>
            {showMap ? "Hide Map" : "Show Map"}
          </button>
          {showMap && (
            <MapComponent
              location={location}
              onDoneClick={handlerOnDoneClick}
              onLocationClick={handleLocationClick}
            />
          )}
          {showMap && <DoubleBackdrop cancel={backdropHandlerDeactivate} />}
          <div>
            <label className={classes.fieldLabels}>{tg("objectives.form.distance")}</label>
          </div>

          <input
            type="number"
            id="distancia"
            className={classes.inputBox}
            name="distancia"
            min="5"
            step="5"
            onChange={(e) => setRadius(e.target.value)}
          ></input>
        </div>
        <div>
          <label className={classes.errorLabel}>{radiusError}</label>
        </div>

        <div className={classes.fieldBox}>
          <label className={classes.fieldLabels} htmlFor="refreshRate">
            {tg("objectives.form.refreshRate")}
          </label>
          <input
            className={classes.inputBox}
            type="number"
            min="0"
            name="fname"
            onChange={(e) => setRefreshRate(e.target.value)}
          />
        </div>
        <div>
          <label className={classes.errorLabel}>{refreshRateError}</label>
        </div>

        <div className={classes.fieldBox}>
          <label className={classes.fieldLabels} htmlFor="type">
            {tg("objectives.form.hideOnMobile")}
          </label>
          <select
          className={classes.select_button}
          name="hideOnMobilePreviousReceiver"
          onChange={(e) => setHideOnMobile(e.target.value)}          
          defaultValue="False"  
        >
          <option value="False">Visible</option>
          <option value="True">Invisible</option>
          
        </select>
        
        <div>
          <label className={classes.errorLabel}>{hideOnMobileError}</label>
        </div>

        </div>

        <input
          type="submit"
          className={classes.submit_button}
          value={tg("global.general.confirm")}
        />
        <input
          type="button"
          className={classes.cancel_button}
          onClick={cancelHandler}
          value={tg("global.general.cancel")}
        />
      </form>
    </div>
  );
}
export default ObjectiveForm;
